export default __webpack_public_path__ + "static/media/tabasher.9513f513.svg";